"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Text = exports.Icon = exports.Item = exports.BottomNavigationWrapper = exports.BottomNavigation = void 0;
const native_1 = __importDefault(require("styled-components/native"));
exports.BottomNavigation = native_1.default.View `
  display: ${(props) => (props.isVisible ? 'flex' : 'none')};
  flex-direction: row;
  background: ${({ theme }) => theme.bottomNavigation.background};
  height: 80px;
  padding-top: 28px;
  border: solid 1px #eaeaea;
`;
exports.BottomNavigationWrapper = native_1.default.View `
  height: 85px;
  overflow: hidden;
`;
exports.Item = native_1.default.TouchableOpacity `
  flex: 1;
`;
exports.Icon = native_1.default.View `
  text-align: center;
  margin: 0 auto;
  justify-content: center;
  margin-bottom: 6px;
`;
exports.Text = native_1.default.Text `
  text-align: center;
  font-size: 10px;
  color: ${({ theme, isFocused }) => isFocused
    ? theme.bottomNavigation.enabled.text
    : theme.bottomNavigation.disabled.text};
`;
